module.exports = __webpack_public_path__ + "static/media/logo_go-munity-softoro.35fca600.png";